import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';

import FindReplace from '@src/containers/Overlays/FindReplace';
import styles from './SearchBar.scss';

/**
 * Simple search bar component that shows a presentation search bar
 * Doesn't implement any input. Simply opens the global search popup onClick
 * @type {Object}
 */
const SearchBar = ({ domain }) => {
  const [searchActive, setSearchActive] = React.useState(false);
  return (
    <div onClick={() => setSearchActive(true)} className={styles.searchBar}>
      <Icon iconType="search" className={styles.searchBarIcon} />
      <FindReplace
        domain={domain}
        active={searchActive}
        onClose={e => {
          e.stopPropagation();
          e.preventDefault();
          setSearchActive(false);
        }}
      />
    </div>
  );
};

SearchBar.propTypes = {
  domain: PropTypes.shape({
    title: PropTypes.string,
  }),
};

SearchBar.defaultProps = {
  domain: {},
};

export default SearchBar;
